module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper video-player-wrapper fixgraybgpl"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.videoSqueeze),
      expression: "!videoSqueeze"
    }],
    staticClass: "video-player-background",
    class: {
      'animated zoomOutLeft': _vm.videoCompleted
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "video-player",
    on: {
      "mouseleave": function($event) {
        _vm.addRightHoverWidthClass ? _vm.resetClass(true) : _vm.resetClass(false)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hideLeftVideoIcons),
      expression: "!hideLeftVideoIcons"
    }],
    staticClass: "left-video-icons"
  }), _vm._v(" "), (_vm.currentVideo) ? _c('div', {
    staticClass: "reset-video-width",
    class: {
      'enjoy-hover': _vm.addEnjoyHoverClass
    }
  }, [_c('jwplayer', {
    attrs: {
      "id": "mainVideoPlayer",
      "data": _vm.currentVideo,
      "on-complete": _vm.onVideoComplete
    }
  }, [_vm._v("Loading the player...")])], 1) : _vm._e()]), _vm._v(" "), (_vm.playlistVideos) ? _c('div', {
    staticClass: "playlistholderdiv"
  }, [(_vm.playlistVideos) ? _c('h4', [_vm._v(" " + _vm._s(_vm.playlistVideos.title))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("(" + _vm._s(_vm.videoIndex) + " of " + _vm._s(_vm.playlistVideos.length) + ")")]), _vm._v(" "), _vm._l((_vm.playlistVideos), function(item) {
    return (_vm.playlistVideos) ? _c('div', [_c('div', {
      staticClass: "playlistentrydiv",
      class: {
        'playing': item.videoCode === _vm.$route.params.videoCode, 'gray': !_vm.user && _vm.getVideoIndex(_vm.playlistVideos, item.videoCode) > 3
      }
    }, [_c('img', {
      directives: [{
        name: "a11y-action",
        rawName: "v-a11y-action"
      }],
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "aria-pressed": (item.videoCode === _vm.$route.params.videoCode) ? 'true' : 'false',
        "aria-label": item.videoTitle,
        "src": item.thumbnailURL,
        "alt": item.videoTitle,
        "title": item.videoTitle
      },
      on: {
        "click": function($event) {
          return _vm.playVideo(item.userPlaylistId, item.videoCode)
        }
      }
    }), _vm._v(" "), _c('p', {
      directives: [{
        name: "a11y-action",
        rawName: "v-a11y-action"
      }],
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "aria-pressed": (item.videoCode === _vm.$route.params.videoCode) ? 'true' : 'false'
      },
      on: {
        "click": function($event) {
          return _vm.playVideo(item.userPlaylistId, item.videoCode)
        }
      }
    }, [_vm._v(_vm._s(item.videoTitle))])])]) : _vm._e()
  }), _vm._v(" "), (_vm.user && _vm.getUserSharedPlaylists[0] && _vm.getUserSharedPlaylists[0].userPlaylistType === 1) ? _c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.copyPlaylist(_vm.$route.params.playlistId, _vm.user.userId)
      }
    }
  }, [_vm._v("\n                        Add to Playlists\n                    ")]) : _vm._e()], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "player-content"
  }, [(_vm.currentVideo) ? _c('h4', [_vm._v(_vm._s(_vm.currentVideo.title) + " (Playing " + _vm._s(_vm.videoIndex) + " of " + _vm._s(_vm.playlistVideos.length) + ")")]) : _vm._e(), _vm._v(" "), (_vm.currentVideo) ? _c('p', [_vm._v("\n                        " + _vm._s(_vm.currentVideo.Description) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.getExpert) ? _c('div', {
    staticClass: "profile-content"
  }, [_c('a', {
    attrs: {
      "href": '/expert/' + _vm.getExpert[0].expertId + '/' + _vm.getExpert[0].name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase(),
      "target": "_blank",
      "rel": "opener"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getExpert[0].small_image,
      "alt": _vm.getExpert[0].name,
      "title": _vm.getExpert[0].name
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.getExpert && _vm.getExpert[0].name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getExpert && _vm.getExpert[0].experties))])])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "video-text"
  }, [_vm._v("\n                        " + _vm._s(_vm.getExpert && _vm.getExpert[0].areasofexpertise) + "\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "recently-watched"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.getAuthRecommendedVideos && _vm.user) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "slider responsive-slick-slider"
  }, _vm._l((_vm.recommendationList), function(reccentVideo) {
    return _c('div', [_c('div', {
      staticClass: "slide-player"
    }, [_c('img', {
      directives: [{
        name: "a11y-action",
        rawName: "v-a11y-action"
      }],
      staticClass: "jw-img",
      attrs: {
        "aria-label": reccentVideo.title,
        "src": reccentVideo.image,
        "title": reccentVideo.title,
        "alt": reccentVideo.title
      },
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(reccentVideo.mediaid, reccentVideo.title)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(reccentVideo.title) + "\n                                    ")])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    on: {
      "click": function($event) {
        return _vm.redirectToRelatedVideos()
      }
    }
  }, [_vm._v("View All Your Videos")])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v("RELATED VIDEOS")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-38b18f5a", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38b18f5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/SharePlaylistPlayer.vue